import { css } from '@emotion/css';

export const avatarGroupStyles = (margin: number) => css`
  .avatar-root:last-child {
    margin-inline-end: 0px;
  }

  .avatar-root {
    margin-inline-end: -${margin}px;
  }
`;

export const avatarMoreStyle = (size: number) => css`
  width: ${size}px;
  height: ${size}px;
`;

export const borderSizeStyle = (border: number) => css`
  box-sizing: content-box;
  border-width: ${border}px;
`;
